export var DocsBlockMultiRichTextPropertyStyle;
(function (DocsBlockMultiRichTextPropertyStyle) {
    /** Ordered list */
    DocsBlockMultiRichTextPropertyStyle["ol"] = "OL";
    /** Unordered list */
    DocsBlockMultiRichTextPropertyStyle["ul"] = "UL";
    /** Default option */
    DocsBlockMultiRichTextPropertyStyle["default"] = "Default";
})(DocsBlockMultiRichTextPropertyStyle || (DocsBlockMultiRichTextPropertyStyle = {}));
